import Factory from '../factory';

const schema = Factory.schema('badges');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('text').setType(String).setValue('Text...');
attributes.prop('image').setType(String).setValue('image-placeholder.svg');
attributes.prop('imageAlt').setType(String);

export default schema;
